import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, firstValueFrom, tap } from 'rxjs';
import { fullAuthenticated } from '../actions/session-auth.actions';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ConfirmDialogComponent } from '@shared/components/dialogs/confirm-dialog/confirm-dialog.component';
import { UserProfileService } from '@core/services/user-profile.service';
import { select, Store } from '@ngrx/store';
import { userProfileSelector } from '../selectors/user-profile.selectors';

@Injectable()
export class ProfileInterestsEffects {
  private readonly actions$ = inject(Actions);
  private readonly dialog = inject(MatDialog);
  private readonly router = inject(Router);
  private readonly userProfileService = inject(UserProfileService);
  private readonly store = inject(Store);

  untouchedInterests$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fullAuthenticated),
        tap(async () => {
          const userProfile = await firstValueFrom(
            this.store.pipe(
              select(userProfileSelector),
              filter((userProfile) => !!userProfile),
            ),
          );
          const isInterestsUntouched = userProfile.interests === undefined;
          const userProfileInterestsUrl = 'dashboard/profile/interests';

          if (isInterestsUntouched) {
            this.dialog
              .open(ConfirmDialogComponent, {
                width: '700px',
                data: {
                  title: 'app.dialog.untouchedInterests.title',
                  content: 'app.dialog.untouchedInterests.content',
                  confirmBtnText: 'app.dialog.untouchedInterests.toInterests',
                  cancelBtnText: 'app.labels.cancel',
                },
              })
              .afterClosed()
              .subscribe((res) => {
                if (res) this.router.navigateByUrl(userProfileInterestsUrl);
                this.userProfileService
                  .updateUserProfile$({ interests: {} })
                  .subscribe();
              });
          }
        }),
      ),
    { dispatch: false },
  );
}
